import { useGetLezsQuery } from "./useGetLezsQuery";

export const useGetLezById = (id: number) => {
  const { data } = useGetLezsQuery();

  return data?.resources.find((lez: { id: number; }) => lez.id === id);
};
